/**
 * Subscribe to manage-backend websocket payment updates for a single order.
 * Returns cleanup fn. Safe no-op when WebSocket unavailable.
 */
export function subscribeOrderPaymentUpdated({ orderId, orderNumber, onUpdate }) {
  if (typeof window === 'undefined' || typeof WebSocket === 'undefined') {
    return () => {};
  }
  const oid = String(orderId || '').trim();
  const onum = String(orderNumber || '').trim();
  if (!oid && !onum) return () => {};

  let ws;
  let closed = false;
  let retryTimer;

  const connect = () => {
    if (closed) return;
    const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    try {
      ws = new WebSocket(`${proto}//${window.location.host}/ws`);
    } catch {
      return;
    }
    ws.onmessage = (ev) => {
      try {
        const msg = JSON.parse(ev.data);
        if (msg?.type !== 'order_payment_updated') return;
        const mid = String(msg.order_id || '').trim();
        const mnum = String(msg.order_number || '').trim();
        if ((oid && mid === oid) || (onum && mnum === onum) || (!mid && !mnum)) {
          onUpdate?.(msg);
        }
      } catch {
        /* ignore */
      }
    };
    ws.onclose = () => {
      if (!closed) retryTimer = window.setTimeout(connect, 4000);
    };
  };

  connect();

  return () => {
    closed = true;
    if (retryTimer) window.clearTimeout(retryTimer);
    try { ws?.close(); } catch { /* ignore */ }
  };
}
